var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSofaChairNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.652,
    height: 24.651,
    viewBox: "0 0 28.652 24.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-armchair-4362911",
    transform: "translate(-23.173 -135.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247832",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247832",
    d: "M193.934,144.053a.282.282,0,0,1-.286-.278v-3.115a4.1,4.1,0,0,0-1.26-2.942,4.371,4.371,0,0,0-3.036-1.221h-11a4.37,4.37,0,0,0-3.036,1.221,4.1,4.1,0,0,0-1.26,2.942v3.074a.287.287,0,0,1-.573,0v-3.074a4.651,4.651,0,0,1,1.427-3.334,4.953,4.953,0,0,1,3.44-1.383h11a4.953,4.953,0,0,1,3.44,1.383,4.651,4.651,0,0,1,1.427,3.334v3.115a.273.273,0,0,1-.084.2.291.291,0,0,1-.2.081Z",
    transform: "translate(-146.438)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247833",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247833",
    d: "M28.676,465.1H26.445c-.5,0-.727-.493-.727-.951V455.8a2.776,2.776,0,0,1-1.207-.576,2.97,2.97,0,0,1,1.955-5.2,2.811,2.811,0,0,1,2.97,2.97v11.151a.988.988,0,0,1-.283.771.722.722,0,0,1-.477.179Zm-.008-.555h.012a.167.167,0,0,0,.107-.043.511.511,0,0,0,.094-.354V452.992a2.263,2.263,0,0,0-2.414-2.414,2.414,2.414,0,0,0-1.582,4.236l.015.014a2.564,2.564,0,0,0,1.157.484.278.278,0,0,1,.216.271v8.561s.019.4.172.4h2.224Z",
    transform: "translate(0 -307.176)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247834",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247834",
    d: "M928.881,465.05a.721.721,0,0,1-.477-.18.985.985,0,0,1-.283-.771V452.947a2.811,2.811,0,0,1,2.97-2.97,2.97,2.97,0,0,1,1.955,5.2,2.777,2.777,0,0,1-1.207.576V464.1c0,.458-.228.951-.727.951h-2.231Zm2.209-14.516a2.263,2.263,0,0,0-2.415,2.414V464.1a.511.511,0,0,0,.094.354.167.167,0,0,0,.107.043.1.1,0,0,1,.026,0h2.21c.153,0,.172-.392.172-.4v-8.562a.277.277,0,0,1,.219-.271,2.536,2.536,0,0,0,1.16-.487l.012-.012a2.414,2.414,0,0,0-1.585-4.235Z",
    transform: "translate(-882.56 -307.131)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247835",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247835",
    d: "M274.871,901.417H258.379a.278.278,0,1,1,0-.555h16.491a.278.278,0,1,1,0,.555Z",
    transform: "translate(-229.036 -747.207)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247836",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247836",
    d: "M268.492,700.094a.283.283,0,0,1-.288-.278V696.1a9.164,9.164,0,0,0-1.55-.406,35.055,35.055,0,0,0-6.373-.469c-6.226,0-8.236.833-8.256.841a.3.3,0,0,1-.224.01.284.284,0,0,1-.164-.147.268.268,0,0,1,0-.216.283.283,0,0,1,.158-.154c.085-.036,2.144-.888,8.491-.888s8.27.964,8.348,1.005a.276.276,0,0,1,.15.244v3.9a.272.272,0,0,1-.084.2.294.294,0,0,1-.2.081Z",
    transform: "translate(-222.711 -545.864)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247837",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247837",
    d: "M172.969,1065.954a.278.278,0,0,1-.278-.278v-2.015a.278.278,0,0,1,.555,0v2.015a.278.278,0,0,1-.278.278Z",
    transform: "translate(-145.659 -906.01)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247838",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247838",
    d: "M998.459,1065.954a.278.278,0,0,1-.278-.278v-2.015a.278.278,0,0,1,.555,0v2.015a.278.278,0,0,1-.278.278Z",
    transform: "translate(-950.961 -906.01)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247839",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247839",
    d: "M256.674,1062.917H239.349a.278.278,0,1,1,0-.555h17.325a.278.278,0,1,1,0,.555Z",
    transform: "translate(-210.457 -905.012)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247840",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247840",
    d: "M554.87,408.318a1.083,1.083,0,0,1-.73-.278.936.936,0,0,1,0-1.4,1.105,1.105,0,0,1,1.461,0,.935.935,0,0,1,0,1.4A1.081,1.081,0,0,1,554.87,408.318Zm0-1.4a.531.531,0,0,0-.356.132.382.382,0,0,0,0,.582.548.548,0,0,0,.713,0,.382.382,0,0,0,0-.582A.531.531,0,0,0,554.87,406.919Z",
    transform: "translate(-517.448 -264.168)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247841",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247841",
    d: "M609.517,385.567a.277.277,0,0,1-.187-.482l.79-.722a.278.278,0,1,1,.374.41l-.791.722A.274.274,0,0,1,609.517,385.567Z",
    transform: "translate(-571.529 -242.595)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247842",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247842",
    d: "M530.227,457.867a.277.277,0,0,1-.187-.482l.79-.722a.278.278,0,1,1,.374.41l-.79.722A.277.277,0,0,1,530.227,457.867Z",
    transform: "translate(-494.163 -313.222)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247843",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247843",
    d: "M609.875,457.74a.278.278,0,0,1-.187-.073l-.79-.722a.278.278,0,1,1,.374-.41l.791.722a.278.278,0,0,1-.187.482Z",
    transform: "translate(-571.096 -313.095)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247844",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247844",
    d: "M531.291,386.072A.277.277,0,0,1,531.1,386l-.79-.722a.278.278,0,0,1,.374-.41l.79.722a.277.277,0,0,1-.187.482Z",
    transform: "translate(-494.436 -243.1)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247845",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247845",
    d: "M816.446,203.155h-.005a.278.278,0,0,1-.273-.283,2.971,2.971,0,0,0-2.482-3.164.278.278,0,0,1,.078-.55,3.811,3.811,0,0,1,1.5.623,3.479,3.479,0,0,1,1.458,3.1.278.278,0,0,1-.275.275Z",
    transform: "translate(-770.75 -61.717)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247846",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247846",
    d: "M979.979,498.51a.277.277,0,0,1-.259-.377,2.039,2.039,0,0,1,2.424-1.115.278.278,0,0,1-.111.544,1.489,1.489,0,0,0-1.8.774A.278.278,0,0,1,979.979,498.51Z",
    transform: "translate(-932.919 -352.663)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247847",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247847",
    d: "M72.944,498.465a.277.277,0,0,1-.259-.377,2.039,2.039,0,0,1,2.423-1.116.278.278,0,1,1-.111.544,1.489,1.489,0,0,0-1.8.774.278.278,0,0,1-.258.175Z",
    transform: "translate(-48.003 -352.618)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247848",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247848",
    d: "M402.6,759.474a.3.3,0,0,1-.044,0,35.267,35.267,0,0,0-8.854,0,.278.278,0,1,1-.077-.549,35.755,35.755,0,0,1,9.019,0,.278.278,0,0,1-.043.553Z",
    transform: "translate(-360.808 -608.266)",
    fill: "#1d1d1f",
    stroke: "#1d1d1f",
    strokeWidth: 0.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSofaChairNew);
export default __webpack_public_path__ + "static/media/icoSofaChairNew.415df0d6115eb63b879b9994e3af8a7a.svg";
export { ForwardRef as ReactComponent };